module.exports = __webpack_public_path__ + "static/media/uncommon.87b35441.png";